import { useState } from "react";
import "./Services.css";
import lifeInsuranceImg from "../assets/images/Life_insurance.png";
import healthInsuranceImg from "../assets/images/Health_insurance.png";
// import autoInsuranceImg from "../assets/images/Auto_insurance.png";
// import propertyInsuranceImg from "../assets/images/Property_insurance.png";
// import riskAssessmentImg from "../assets/images/Risk_assesment.png";
import claimsSupportImg from "../assets/images/Claim_support.png";

const Services = () => {
  const [flippedCards, setFlippedCards] = useState({});

  const services = [
    {
      id: 1,
      image: lifeInsuranceImg,
      title: "Life Insurance",
      description: "Comprehensive coverage for your family's future",
      details: [
        "Term Life Insurance",
        "Whole Life Insurance",
        "Final Expense Insurance",
        "Group Life Plans",
      ],
      summary:
        "Protect your loved ones with tailored life insurance solutions that fit your budget and needs.",
      link: "https://www.hdfc.bank.in/life-insurance",
    },
    {
      id: 2,
      image: healthInsuranceImg,
      title: "Health Insurance",
      description: "Medical coverage for peace of mind",
      details: [
        "Individual & Family Plans",
        "HMO & PPO Options",
        "Short-term Plans",
        "Medicare Supplements",
      ],
      summary:
        "Stay protected against medical expenses with comprehensive health insurance coverage.",
      link: "https://www.icicilombard.com/health-insurance",
    },
    // {
    //   id: 3,
    //   image: autoInsuranceImg,
    //   title: "Auto Insurance",
    //   description: "Drive with confidence and protection",
    //   details: [
    //     "Liability Coverage",
    //     "Collision Coverage",
    //     "Comprehensive",
    //     "Uninsured Motorist",
    //     "Gap Insurance",
    //   ],
    //   summary:
    //     "Protect your vehicle and yourself on the road with reliable auto insurance options.",
    // },
    // {
    //   id: 4,
    //   image: propertyInsuranceImg,
    //   title: "Property Insurance",
    //   description: "Safeguard your home and belongings",
    //   details: [
    //     "Homeowners Insurance",
    //     "Renters Insurance",
    //     "Flood Insurance",
    //     "Earthquake Coverage",
    //     "Valuable Items",
    //   ],
    //   summary:
    //     "Protect your property investment with comprehensive coverage against various risks.",
    // },
    // {
    //   id: 5,
    //   image: riskAssessmentImg,
    //   title: "Risk Assessment",
    //   description: "Personalized risk evaluation services",
    //   details: [
    //     "Comprehensive Analysis",
    //     "Coverage Gap Review",
    //     "Risk Mitigation",
    //     "Policy Optimization",
    //     "Annual Reviews",
    //   ],
    //   summary:
    //     "Get a thorough evaluation of your insurance needs and identify areas for improvement.",
    // },
    {
      id: 6,
      image: claimsSupportImg,
      title: "Claims Support",
      description: "Expert assistance during claims process",
      details: [
        "Claims Filing Help",
        "Documentation Support",
        "Status Updates",
        "Appeals Assistance",
        "24/7 Support",
      ],
      summary:
        "Navigate the claims process smoothly with our expert guidance and support.",
    },
  ];

  const handleCardClick = (index) => {
    setFlippedCards((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <section className="services-section" id="services">
      <div className="services-container">
        <div className="section-header">
          <h2>Expertise & Services</h2>
          <p>Comprehensive insurance solutions tailored to your needs</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`service-card ${flippedCards[index] ? "flipped" : ""}`}
              onClick={() => handleCardClick(index)}
            >
              <div className="card-inner">
                <div className="card-front">
                  <div className="service-image">
                    <img src={service.image} alt={service.title} />
                  </div>
                  <h4>{service.title}</h4>
                  <p>{service.description}</p>
                </div>
                <div className="card-back">
                  <h4>{service.title}</h4>
                  <ul>
                    {service.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                  <p>{service.summary}</p>
                  {service.link && (
                    <a
                      href={service.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="more-info-link"
                    >
                      Click here for more info
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
